import { CustomGridProps } from "@/types/AppTypes";
import CustomGrid from "../customGrid/CustomGrid";
import { cn } from "@/lib/utils";
import React from "react";

const ProductGrid: React.FC<CustomGridProps> = React.memo(
  ({
    sectionHeader = null,
    gridItems = [],
    className = "",
    GridItemClassName = "",
    onAddToCart = () => {},
    loading = false,
    skeletonCount = 8,
  }) => {
    return (
      <>
        <CustomGrid
          sectionHeader={sectionHeader}
          gridItems={gridItems}
          isProduct={true}
          className={cn("px-1", className)}
          GridItemClassName={GridItemClassName}
          onAddToCart={onAddToCart}
          loading={loading}
          skeletonCount={skeletonCount}
        />
      </>
    );
  }
);

export default ProductGrid;
